/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Reducer } from 'redux';
import IAction from '../model/IAction';
import IFocusState, { initialFocusState } from '../model/IFocusState';
import * as ACTION_TYPES from '../actionType/focus';

const focusReducer: Reducer<IFocusState, IAction> = (state: IFocusState = initialFocusState, action: IAction): IFocusState => {
  switch (action.type) {
    case ACTION_TYPES.CHANGE_FOCUSED_STEP:
      return {
        ...initialFocusState,
        step: action.payload.step,
      };
    case ACTION_TYPES.CHANGE_FOCUSED_ALTERNATIVE:
      return {
        ...initialFocusState,
        alternative: { stepId: action.payload.stepId, poi: action.payload.poi },
      };
    case ACTION_TYPES.CHANGE_FOCUSED_POI:
      return {
        ...initialFocusState,
        poi: action.payload.poi,
      };
    case ACTION_TYPES.CLEAR_FOCUS:
      return initialFocusState;

    default:
      return state;
  }
};

export default focusReducer;
